import Footer from "../components/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import Audit from "../images/audit.png";

export default function Audits() {
  return (
    <>
        <NavBar />
        <ServiceDetail
          titleKey="services.s4_title"
          descriptionKey="services.s4_more"
          image={Audit}
          highlights={[
              "services.s4_point_1",
              "services.s4_point_2",
              "services.s4_point_3",
          ]}
        />
        <Footer />
    </>
  );
}
